/** Placeholder for custom snow/mountain drawings Gabriela will add later */
export function IllustrationSlot({
  kind = 'mountain',
  className = '',
  caption,
}: {
  kind?: 'mountain' | 'snowflake' | 'trip' | 'passport'
  className?: string
  caption?: string
}) {
  return (
    <div className={`illus-slot illus-${kind} ${className}`.trim()} aria-hidden>
      <svg viewBox="0 0 120 80" className="illus-svg">
        {kind === 'snowflake' && (
          <>
            <circle cx="60" cy="40" r="3" fill="currentColor" opacity="0.35" />
            {[0, 60, 120, 180, 240, 300].map((a) => {
              const rad = (a * Math.PI) / 180
              const x2 = 60 + Math.cos(rad) * 28
              const y2 = 40 + Math.sin(rad) * 28
              return (
                <line
                  key={a}
                  x1="60"
                  y1="40"
                  x2={x2}
                  y2={y2}
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  opacity="0.28"
                />
              )
            })}
          </>
        )}
        {kind === 'mountain' && (
          <>
            <path d="M8 68 L40 22 L58 48 L72 30 L112 68 Z" fill="currentColor" opacity="0.12" />
            <path
              d="M8 68 L40 22 L58 48 L72 30 L112 68 Z"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              opacity="0.35"
            />
            <circle cx="96" cy="18" r="7" fill="currentColor" opacity="0.18" />
          </>
        )}
        {kind === 'trip' && (
          <>
            <circle cx="42" cy="34" r="10" fill="none" stroke="currentColor" strokeWidth="1.8" opacity="0.35" />
            <circle cx="78" cy="38" r="8" fill="none" stroke="currentColor" strokeWidth="1.8" opacity="0.28" />
            <path
              d="M22 64c4-12 12-18 20-18s16 6 20 18"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              opacity="0.3"
            />
            <path
              d="M62 64c3-8 8-12 14-12 6 0 11 4 14 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              opacity="0.25"
            />
          </>
        )}
        {kind === 'passport' && (
          <>
            <rect x="28" y="12" width="64" height="56" rx="6" fill="none" stroke="currentColor" strokeWidth="1.8" opacity="0.3" />
            <path d="M28 28h64" stroke="currentColor" strokeWidth="1.5" opacity="0.25" />
            <circle cx="48" cy="48" r="8" fill="currentColor" opacity="0.12" />
            <path d="M62 44h22M62 52h16" stroke="currentColor" strokeWidth="1.5" opacity="0.25" strokeLinecap="round" />
          </>
        )}
      </svg>
      {caption && <span className="illus-caption">{caption}</span>}
    </div>
  )
}
